
export default {
    name: 'close',
    methods: {
        close() {
            this.$emit('close');
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/close/close.js